import React,{useState} from 'react'
import GameRoutes from '../../route/gameroutes/GameRoutes'
import SearchBar from '../../route/searchbar/SearchBar'
import Token from '../../component/token/Token'
import './FreefirePage.scss'
import ceklis from '../../assets/ceklis.png'
import ff from '../../assets/freefire.png'
import Terms from '../../component/termsmodal/Terms'
import Activation from '../../component/activation/Activation'

const FreefirePage = () => {

    const [show,setShow] = useState(false)
    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)
    const [show4,setShow4] = useState(false)

    const [showAct,setShowAct] = useState(false)


    const close = () => {
        setShow(false)
        setShow2(false)
        setShow3(false)
        setShow4(false)
        setShowAct(false)
    }
    return (
        <>
            <div className="freefire__white">
                <div className="freefire__container">
                    <SearchBar/>
                    <GameRoutes/>
                    <div className="freefire__header">
                        <div className="freefire__text">
                            <p>FF</p>
                        </div>
                        <div className="freefire__activated" onClick={() => setShowAct(true)}>
                            <img src={ceklis} alt="ceklis"/>
                            <p>Activated</p>
                        </div>
                    </div>
                    <Token onClick={() => setShow(true)} onClick2={() => setShow2(true)} onClick3={() => setShow3(true)} onClick4={() => setShow4(true)}/>
                        {show && <Terms bgCover="ff--modal" header="SOLO LEAGUE" onClose={close} imagelogo={ff}/>}
                        {show2 && <Terms bgCover="ff--modal" header="SOLO Challange" onClose={close} imagelogo={ff}/>}
                        {show3 && <Terms bgCover="ff--modal" header="TEAM Round of 8" onClose={close} imagelogo={ff}/>}
                        {show4 && <Terms bgCover="ff--modal" header="TEAM LEAGUE" onClose={close} imagelogo={ff}/>}
                        {showAct && <Activation bgCover="ff--bg" onClose={close} imageLogo={ff}/>}
                </div>
            </div>
        </>
    )
}

export default FreefirePage
